import "core-js/modules/es.regexp.to-string.js";
/**
 * Generate unique request ID
 */
export function generateRequestId() {
  return `req_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
}

/**
 * Generate unique instance ID
 */
export function generateInstanceId() {
  return `inst_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
}